import React from "react";
import {
  Container,
  Grid,
  Segment,
  Header,
  Icon,
  Card,
  Button,
} from "semantic-ui-react";
import { useNavigate } from "react-router-dom";

const Configuracion = () => {
  const navigate = useNavigate();

  const opciones = [
    {
      titulo: "Usuarios y Roles",
      descripcion:
        "Gestiona usuarios, permisos y perfiles de acceso del sistema.",
      icono: "users",
      color: "#3b82f6",
      bg: "#eff6ff",
      ruta: "/configuracion/registrausuarios",
    },
    {
      titulo: "Alertas y Notificaciones",
      descripcion:
        "Configura correos, alertas de mantención y avisos operacionales.",
      icono: "bell",
      color: "#10b981",
      bg: "#ecfdf5",
      ruta: "/configuracion/envios",
    },
  ];

  return (
    <Container fluid style={{ padding: "25px" }}>
      <Segment
        raised
        style={{
          borderRadius: 20,
          padding: "35px",
          minHeight: "82vh",
          border: "1px solid #e5e7eb",
          boxShadow: "0 12px 35px rgba(0,0,0,0.06)",
          background:
            "linear-gradient(to bottom right, #ffffff, #f8fafc)",
        }}
      >
        {/* HERO */}
        <Grid stackable verticalAlign="middle">
          <Grid.Row columns={2}>
            <Grid.Column width={10}>
              <div style={{ marginBottom: 12 }}>
                <span
                  style={{
                    color: "#2563eb",
                    fontWeight: 700,
                    fontSize: 14,
                    letterSpacing: 1,
                    textTransform: "uppercase",
                  }}
                >
                  CONFIGURACIÓN
                </span>
              </div>

              <Header
                as="h1"
                style={{
                  fontSize: "3rem",
                  marginBottom: 10,
                  color: "#111827",
                }}
              >
                Centro de Configuración
              </Header>

              <p
                style={{
                  fontSize: 18,
                  color: "#6b7280",
                  maxWidth: 650,
                  lineHeight: 1.7,
                }}
              >
                Administra los parámetros, usuarios y alertas que
                controlan el funcionamiento de LogisticMed.
              </p>

              <div
                style={{
                  width: 80,
                  height: 4,
                  background: "#2563eb",
                  borderRadius: 20,
                  marginTop: 25,
                }}
              />
            </Grid.Column>

            <Grid.Column
              width={6}
              textAlign="center"
              only="computer tablet"
            >
              <div
                style={{
                  position: "relative",
                }}
              >
                <div
                  style={{
                    width: 260,
                    height: 260,
                    margin: "0 auto",
                    borderRadius: "50%",
                    background:
                      "radial-gradient(circle, rgba(59,130,246,0.15) 0%, rgba(255,255,255,0) 70%)",
                    position: "absolute",
                    left: "50%",
                    top: "50%",
                    transform: "translate(-50%, -50%)",
                  }}
                />

                <Icon
                  name="settings"
                  size="massive"
                  color="blue"
                  style={{
                    opacity: 0.85,
                  }}
                />
              </div>
            </Grid.Column>
          </Grid.Row>
        </Grid>

        {/* TARJETAS */}
        <Grid stackable columns={4} style={{ marginTop: 30 }}>
          {opciones.map((item, index) => (
            <Grid.Column key={index}>
              <Card
                fluid
                style={{
                  borderRadius: 18,
                  border: "1px solid #eef2f7",
                  boxShadow: "0 8px 25px rgba(15,23,42,0.05)",
                  transition: "0.2s ease",
                  minHeight: 240,
                }}
              >
                <Card.Content
                  style={{
                    padding: 24,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                  }}
                >
                  <div>
                    <div
                      style={{
                        width: 70,
                        height: 70,
                        borderRadius: 18,
                        background: item.bg,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginBottom: 20,
                      }}
                    >
                      <Icon
                        name={item.icono}
                        size="big"
                        style={{
                          color: item.color,
                          margin: 0,
                        }}
                      />
                    </div>

                    <Header
                      as="h3"
                      style={{
                        fontSize: 24,
                        color: "#111827",
                        marginBottom: 10,
                      }}
                    >
                      {item.titulo}
                    </Header>

                    <p
                      style={{
                        color: "#6b7280",
                        lineHeight: 1.7,
                        fontSize: 15,
                      }}
                    >
                      {item.descripcion}
                    </p>
                  </div>

                  <div style={{ marginTop: 25 }}>
                    <Button
                      fluid
                      onClick={() => navigate(item.ruta)}
                      style={{
                        borderRadius: 10,
                        background: item.color,
                        color: "#fff",
                        fontWeight: 600,
                      }}
                    >
                      Ingresar
                      <Icon
                        name="arrow right"
                        style={{ marginLeft: 8 }}
                      />
                    </Button>
                  </div>
                </Card.Content>
              </Card>
            </Grid.Column>
          ))}
        </Grid>

        {/* INFO */}
        <Segment
          style={{
            marginTop: 35,
            borderRadius: 18,
            border: "none",
            background:
              "linear-gradient(to right, #eff6ff, #f8fafc)",
            padding: "20px 25px",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 18,
            }}
          >
            <div
              style={{
                width: 55,
                height: 55,
                borderRadius: 14,
                background: "#dbeafe",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Icon
                name="shield alternate"
                color="blue"
                size="large"
              />
            </div>

            <div>
              <div
                style={{
                  fontWeight: 700,
                  color: "#1e3a8a",
                  marginBottom: 5,
                  fontSize: 16,
                }}
              >
                Acceso restringido
              </div>

              <div
                style={{
                  color: "#64748b",
                  fontSize: 14,
                }}
              >
                Las opciones de configuración están disponibles solo
                para usuarios autorizados.
              </div>
            </div>
          </div>
        </Segment>
      </Segment>
    </Container>
  );
};

export default Configuracion;